import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, ArrowRightIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
const Services: React.FC = () => {
  return <div className="min-h-screen pt-32 pb-20" data-id="element-379">
      {/* Hero Section */}
      <section className="container mx-auto px-4 py-20 text-center" data-id="element-380">
        <motion.h1 className="text-4xl md:text-6xl font-bold mb-8" initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 0.5,
        delay: 0.2
      }} data-id="element-381">
          CHOOSE YOUR BLUEPRINT FOR GROWTH
        </motion.h1>
        <motion.p className="font-thin text-lg max-w-3xl mx-auto" initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 0.5,
        delay: 0.4
      }} data-id="element-382">
          Clear, transparent pricing for every stage of your business. Below
          you'll find a la carte services to meet your specific needs, as well
          as my complete, all-in-one solution.
        </motion.p>
      </section>
      {/* A La Carte Services */}
      <section className="container mx-auto px-4 py-20" data-id="element-383">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-384">
          <ServiceCard title="Market Research Blueprint" price={100} items={['In-depth Market Analysis & Comprehensive Report', 'Detailed Target Audience Persona & Analysis', 'Curated List of Key Competitors', 'Forensic Competitor Analysis & Strategic Insights', 'Actionable Recommendations to Differentiate Your Brand', 'Data-Driven Platform Identification']} deliverable="A clear understanding of your market landscape, delivered via a comprehensive report, Excel database, and a professional visual presentation." data-id="element-385" />
          <ServiceCard title="Digital Presence Audit" price={100} items={['Full Audit of Your Current Digital Strategy', 'Honest, Unbiased Evaluation of Strengths & Weaknesses', 'A Clear, Prioritized Action Plan for Improvement', 'Strategic Recommendations for Immediate Impact']} deliverable="A complete understanding of what to fix, presented in a clear roadmap to increase your sales and impact." data-id="element-386" />
          <ServiceCard title="Brand Identity Kit" price={150} items={['Comprehensive Audit of Your Existing Brand', 'Crafting Your Core Brand Messaging & Story', 'Development of 2 Unique Logo Concepts', 'Creation of 2 Professional Color Palettes', 'Selection of 2 Professional Font Pairings', 'A Suite of 5 High-Fidelity Brand Mockups']} deliverable="A complete, ready-to-use professional Brand Kit with all visual assets and a comprehensive presentation." data-id="element-387" />
          <ServiceCard title="Custom Growth Strategy" price={150} items={['In-depth Discovery Session to Understand Your Business', 'A Custom-Tailored Strategic Solution for Your Unique Problems']} deliverable="An experienced, personalized strategy document that provides a clear and actionable roadmap for your business growth." data-id="element-388" />
          <ServiceCard title="Organic Social Media Marketing" price={200} items={['Full Audit & Strategy for 3 Social Platforms (Excluding LinkedIn)', 'Professional Account Creation & Optimization', 'Complete Profile Visuals (Profile Image & Banner)', 'A Content Calendar of 20 High-Engagement Posts', 'Expertly Researched Captions & Trending Hashtags', 'Full Content Scheduling Across All Platforms']} deliverable="A professional and active social media presence with 20 days of high-end content, managed for you." data-id="element-389" />
          <ServiceCard title="WordPress Website Development" price={200} items={['A Professional 6-7 Page Modern Minimalist Website', 'Highly Interactive & Smooth User Experience', 'Full Social Media & WhatsApp Integration', 'Expertly Written SEO-Optimized Foundational Content']} deliverable="A professional website that acts as your 24/7 digital salesperson. (Hosting & Domain Not Included)" data-id="element-390" />
          <ServiceCard title="LinkedIn Authority Builder" price={180} items={['Complete Personal & Company Profile Architecture', 'Optimization of all Key Sections', 'A Content Plan of 10 Image Posts, 10 Written Posts, 3 Articles, & 2 PDF Carousels', 'Strategic Network Growth (150+ Connections & 200+ Invites)', 'Proactive Engagement & Interaction Messaging']} deliverable="A powerful, professional LinkedIn presence for both you and your company, perfectly positioned to attract high-value B2B clients." data-id="element-391" />
          <ServiceCard title="Social Media Management & Ads (1 Month)" price={350} items={['Full Management for Meta (Facebook/Instagram) & Twitter', 'A Content Plan of 30 Posts, 10 Stories, & 2 Edited Reels/Animations', 'Full Profile Management', 'Comprehensive Weekly Performance Reports', 'A Complete Meta Ad Campaign: - 3 High-Performance Ad Creatives, - 3 High-Conversion Ad Copies, - 12 Days of Strategic A/B Testing & Optimization, - Delivery of 1 Winning Ad Campaign & Ad Set']} deliverable="A professionally managed social presence and a data-driven ad campaign designed to deliver exceptional results." data-id="element-392" />
        </div>
      </section>
      {/* Signature Offer */}
      <section className="container mx-auto px-4 py-20" data-id="element-393">
        <div className="border-4 border-[#39FF14] rounded-3xl p-8 md:p-12" data-id="element-394">
          <div className="text-center mb-8" data-id="element-395">
            <h2 className="text-3xl md:text-5xl font-bold mb-4" data-id="element-396">
              The Full Digital Ecosystem Package
            </h2>
            <p className="text-4xl md:text-6xl font-bold text-[#39FF14] mb-6" data-id="element-397">
              $1000
            </p>
            <p className="font-thin text-lg max-w-3xl mx-auto" data-id="element-398">
              This is my all-in-one, flagship service for businesses ready for a
              complete growth partner. It combines every single one of my expert
              services into a single, cohesive, and professionally managed
              system designed for maximum results.
            </p>
          </div>
          <div className="flex justify-center" data-id="element-399">
            <Link to="/contact" className="bg-[#39FF14] text-black px-8 py-4 rounded-full font-bold hover:bg-opacity-80 transition-all flex items-center" data-id="element-400">
              Book a Discovery Call
              <ArrowRightIcon className="ml-2 w-5 h-5" data-id="element-401" />
            </Link>
          </div>
        </div>
      </section>
    </div>;
};
interface ServiceCardProps {
  title: string;
  price: number;
  items: string[];
  deliverable: string;
}
const ServiceCard: React.FC<ServiceCardProps> = ({
  title,
  price,
  items,
  deliverable
}) => {
  return <motion.div whileHover={{
    y: -5
  }} className="bg-white dark:bg-[#121212] rounded-xl shadow-lg overflow-hidden" data-id="element-402">
      <div className="p-6" data-id="element-403">
        <h3 className="text-xl font-bold mb-2" data-id="element-404">{title}</h3>
        <p className="text-2xl font-bold text-[#39FF14] mb-6" data-id="element-405">${price}</p>
        <ul className="space-y-3 mb-6" data-id="element-406">
          {items.map((item, index) => <li key={index} className="flex items-start" data-id="element-407">
              <CheckIcon className="w-5 h-5 text-[#39FF14] mr-2 flex-shrink-0 mt-0.5" data-id="element-408" />
              <p className="font-thin text-sm" data-id="element-409">{item}</p>
            </li>)}
        </ul>
        <div className="border-t border-gray-200 dark:border-gray-700 pt-4 mt-4" data-id="element-410">
          <p className="font-thin text-sm mb-2" data-id="element-411">Final Deliverable:</p>
          <p className="font-normal text-sm" data-id="element-412">{deliverable}</p>
        </div>
      </div>
    </motion.div>;
};
export default Services;